import React from "react";
import {
  Box,
  Typography,
  IconButton,
  CircularProgress,
  Grid,
} from "@mui/material";
import { Edit, Save, Close } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import useEditableSectionLogic from "./EditableSection1";
import renderField from "./EditableSection2";
import { isLoggedIn } from "../../../../Utility/helper";
import "./PL.css";

const EditableSection = ({ title, icon, data, fields, onSave }) => {
  const {
    editMode,
    formData,
    isSaving,
    errors,
    handleChange,
    handleSave,
    setEditMode,
    setFormData,
    setErrors,
  } = useEditableSectionLogic(data, onSave);

  const loggedIn = isLoggedIn();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box className="editable-section">
        <Box className="editable-header">
          <Typography variant="h6" className="editable-title">
            {icon} {title}
          </Typography>
          <Box>
            {editMode ? (
              <>
                <IconButton size="small" onClick={handleSave} disabled={isSaving}>
                  {isSaving ? <CircularProgress size={20} /> : <Save fontSize="small" />}
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    setFormData(data || {});
                    setErrors({});
                    setEditMode(false);
                  }}
                  disabled={isSaving}
                >
                  <Close fontSize="small" />
                </IconButton>
              </>
            ) : (
              loggedIn && (
                <IconButton size="small" onClick={() => setEditMode(true)}>
                  <Edit fontSize="small" />
                </IconButton>
              )
            )}
          </Box>
        </Box>

        <Grid container spacing={2}>
          {fields.map((field) =>
            renderField({
              field,
              value: formData?.[field.name] || "",
              error: errors[field.name],
              editMode,
              isSaving,
              handleChange,
            })
          )}
        </Grid>
      </Box>
    </LocalizationProvider>
  );
};

export default EditableSection;